export type BookerSubmitThemeType = 'primary' | 'secondary';

export type ButtonThemeType = 'ctaPrimary' | 'ctaSecondary';

export const BOOKER_SUBMIT_BUTTON_THEME_MAP: {
  [key in BookerSubmitThemeType]: ButtonThemeType;
} = {
  primary: 'ctaPrimary',
  secondary: 'ctaSecondary',
};
